module.exports = __webpack_public_path__ + "img/family.5ce9481a.png";